import Card from "@/components/Card";
import React from "react";

import StrategyTable from "./StrategyTable";
import { Divider } from "antd";

export default () => {
  return (
    <Card title="Strategy Builder" bordered={true}>
      <StrategyTable isBuy={true} />
      <Divider />
      <StrategyTable isBuy={false} />
    </Card>
  );
};
